"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.span_closure = void 0;
function span_closure(spans) {
    if (spans.length === 0) {
        throw new Error("I can not calculate the closure of empty array of spans, at least one span is needed.");
    }
    const lo = Math.min(...spans.map((span) => span.lo));
    const hi = Math.max(...spans.map((span) => span.hi));
    return { lo, hi };
}
exports.span_closure = span_closure;
//# sourceMappingURL=span-union.js.map